import { render } from "./post-smtp-settings-menu.vue?vue&type=template&id=01624a62&scoped=true"
import script from "./post-smtp-settings-menu.vue?vue&type=script&lang=js"
export * from "./post-smtp-settings-menu.vue?vue&type=script&lang=js"

import "./post-smtp-settings-menu.vue?vue&type=style&index=0&id=01624a62&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01624a62"]])

export default __exports__